// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { DataProvider } from './src/DataContext';

const DealsPage = lazy(() => import('./src/components/DealsPage'));
const TraitsPage = lazy(() => import('./src/components/TraitsPage'));
const SellPage = lazy(() => import('./src/components/SellPage'));
const TraitGambling = lazy(() => import('./src/components/TraitGambling')); // Import the new page
const BestUseOfPage = lazy(() => import('./src/components/BestUseOfPage')); // Import the new page

function App() {
    return (
        <DataProvider>
            <Router>
                <div className="container mt-4">
                    <Navigation />
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            <Route path="/" element={<DealsPage />} />
                            <Route path="/traits" element={<TraitsPage />} />
                            <Route path="/sell" element={<SellPage />} />
                            <Route path="/trait-gambling" element={<TraitGambling />} />
                            <Route path="/bestuseof" element={<BestUseOfPage />} />
                            </Routes>
                    </Suspense>
                </div>
            </Router>
        </DataProvider>
    );
}

function Navigation() {
    return (
        <nav className="mb-4">
            <Link to="/" className="btn btn-primary me-2">Deals</Link>
            <Link to="/traits" className="btn btn-primary me-2">Traits</Link>
            <Link to="/sell" className="btn btn-primary">Sell</Link>
            <Link to="/trait-gambling" className="btn btn-primary ms-2">Trait Gambling</Link>
            <Link to="/bestuseof" className="btn btn-primary ms-2">Best Use Of</Link>
        </nav>
    );
}

export default App;
